import { render, staticRenderFns } from "./UserSocialForm.vue?vue&type=template&id=7427f55c&scoped=true&"
import script from "./UserSocialForm.vue?vue&type=script&lang=js&"
export * from "./UserSocialForm.vue?vue&type=script&lang=js&"
import style0 from "./UserSocialForm.vue?vue&type=style&index=0&id=7427f55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7427f55c",
  null
  
)

export default component.exports